module.exports = __webpack_public_path__ + "static/media/caret.372b14fb.svg";